import {createRouter, createWebHistory} from 'vue-router'
import {getToken} from "@/utils/auth.js";
import { lastRoute } from './lastRoute'
const views = import.meta.glob('../views/**/*.vue')
const metas = {
    ...import.meta.glob('../views/**/page.js', { eager: true, import: 'default' }),
    ...import.meta.glob('../views/**/_page.js', { eager: true, import: 'default' })
}
function normalizePath(filePath) {
    return filePath
            .replace('../views', '')
            .replace(/\/index.vue$/, '')
            .replace(/\.vue$/, '')
            .replace(/\[\.{3}(.*)\]/g, ':$1(.*)')
            .replace(/_(.*)/g, ':$1')
        || '/'
}
const routes = Object.entries(views).map(([path, component]) => {
    const routePath = `${normalizePath(path)}`
    const name = routePath === '/' ? 'index' : routePath.slice(1).replace(/\//g, '-')
    const metaPath = path.replace('_id', '_page').replace('index', 'page').replace('.vue', '.js').replace('/[', '/').replace(/\]$/, '')
    const meta = metas[metaPath] || {}
    return {
        path: routePath,
        name,
        component,
        meta
    }
})
routes.push({
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: views['../views/404.vue'] || (() => import('../views/404.vue')),
    meta: { hideLayout: true }
})
const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        // 如果有儲存的滾動位置（例如使用瀏覽器返回），則使用該位置
        if (savedPosition) {
            return savedPosition
        } else {
            return { top: 0 }
        }
    },
});

const whiteList = ['/login','/register','/checkDetails'] // 白名單路由
function setDocumentTitle(to) {
    document.title = to.meta?.title || '首頁'
}
router.beforeEach((to, from, next) => {
    const token = getToken()
    if (to.path !== '/login') {
        lastRoute.value = to.fullPath
    }
    if (whiteList.includes(to.path)) {
        setDocumentTitle(to)
        return next()
    }
    if (!token) {
        return next(`/login?redirect=${lastRoute.value}`)
    }
    setDocumentTitle(to)
    next()
})
export default router
